import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    transition:
      transform 0.15s ease,
      color 0.15s ease;

    svg {
      height: 22px;
      width: 22px;
    }

    &:hover {
      transform: translateY(-1px) scale(1.05);
    }

    &:active {
      transform: translateY(0) scale(0.97);
    }
  }
`

export const Th = styled.th`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  padding: 8px 12px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Td = styled.td`
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.tableRowAlt};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tableRowHover};
  }
`

export const TableContainer = styled.div`
  overflow-x: auto;
  max-width: 100%;
`

export const AddButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  border: none;
  padding: 10px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.95rem;
  transition:
    background-color 0.15s ease,
    transform 0.15s ease;

  svg {
    height: 20px;
    width: 20px;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.primaryHover || theme.colors.primary};
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ChartLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 8px 0 16px;
  font-size: 0.9rem;

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .swatch {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  .swatch.line {
    width: 18px;
    height: 3px;
    border-radius: 0;
  }
`

export const SectionTitle = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  margin: 16px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '●';
    color: #667eea;
    font-size: 1.2rem;
  }
`
